import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-privacy-policy-social-media',
    templateUrl: './privacy-policy-social-media.component.html',
    styleUrl: './privacy-policy-social-media.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PrivacyPolicySocialMediaComponent implements OnInit {
  public componentData: CmsLinkComponent;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });

  }
}
